import React from 'react';

import FormSwitcher from '../FormSwitcher/FormSwitcher';
import SignUpForm from './SignupForm/SignUpForm';

import styles from './SignUp.module.scss';

type Props = {
  pageType?: 'account' | 'checkout';
  classes?: Partial<{
    container: string;
  }>;
};

export default function SignUp({
  pageType = 'account',
  classes,
}: Props): JSX.Element {
  return (
    <div className={classes?.container}>
      <FormSwitcher active={'create'} isCheckout={pageType === 'checkout'} />
      <SignUpForm
        classes={{ container: styles.formContainer }}
        isCheckoutPage={pageType === 'checkout'}
      />
    </div>
  );
}
